import {forward} from 'effector';

import {RestError, showRestError} from 'core/errors';

import {
    addFactories,
    addFactoriesBatchFx,
    editFactoryBatchFx,
    isCreateModalOpenChanged,
    isEditModalOpenChanged,
    updateFactory,
} from './index';

forward({
    from: addFactories,
    to: addFactoriesBatchFx,
});

forward({
    from: updateFactory,
    to: editFactoryBatchFx,
});

addFactoriesBatchFx.done.watch(() => {
    isCreateModalOpenChanged(false);
});

editFactoryBatchFx.done.watch(() => {
    isEditModalOpenChanged(false);
});

addFactoriesBatchFx.fail.watch(({error}) => showRestError(error as RestError));
editFactoryBatchFx.fail.watch(({error}) => showRestError(error as RestError));
